<script lang="ts">
  import { auth } from "$lib/stores/auth.svelte";
  import { navigate } from "$lib/router.svelte";

  let billing = $derived(auth.billing);
  let show = $derived(
    billing !== null &&
    (billing.plan === "trial" || billing.plan === "expired")
  );
  let isExpired = $derived(billing?.plan === "expired");
  let daysLeft = $derived(billing?.days_left ?? 0);
  let isLastDay = $derived(daysLeft === 1 && !isExpired);
  let urgent = $derived(daysLeft <= 3 && !isExpired);
</script>

{#if show}
  <div
    class="w-full px-4 py-2.5 flex items-center justify-between text-sm font-medium gap-3
      {isExpired
        ? 'bg-red-950 border-b border-red-800 text-red-200'
        : isLastDay
          ? 'bg-red-950 border-b border-red-800 text-red-200'
          : urgent
            ? 'bg-amber-950 border-b border-amber-800 text-amber-200'
            : 'bg-indigo-950 border-b border-indigo-800 text-indigo-200'}"
  >
    <span class="flex items-center gap-2 min-w-0">
      {#if isExpired}
        <span class="text-base">⛔</span>
        <span>Plano expirado — somente leitura. Seus dados estão seguros.</span>
      {:else if isLastDay}
        <span class="text-base">🔥</span>
        <span>
          <strong>Último dia de trial!</strong> Amanhã você não conseguirá lançar novas transações.
        </span>
      {:else if urgent}
        <span class="text-base">⚠️</span>
        <span>
          Trial expira em <strong>{daysLeft} dia{daysLeft !== 1 ? 's' : ''}</strong> — assine para continuar lançando.
        </span>
      {:else}
        <span class="text-base">🎉</span>
        <span>Trial gratuito —
          <strong>{daysLeft} dia{daysLeft !== 1 ? 's' : ''}</strong> de acesso completo restante{daysLeft !== 1 ? 's' : ''}.
        </span>
      {/if}
    </span>
    <button
      onclick={() => navigate("/upgrade")}
      class="shrink-0 px-3 py-1.5 rounded-lg text-xs font-semibold whitespace-nowrap transition
        {isExpired || isLastDay
          ? 'bg-red-600 hover:bg-red-500 text-white'
          : urgent
            ? 'bg-amber-600 hover:bg-amber-500 text-white'
            : 'bg-indigo-600 hover:bg-indigo-500 text-white'}"
    >
      {isExpired ? "Reativar conta" : "Ver planos →"}
    </button>
  </div>
{/if}
